import React from 'react';
import type { ColumnsType } from '@duxton-web/ui/es/table';

import { ExperimentTabView } from './use-experiments-url-state';
import { DashboardTable } from '@/common/components';
import { Filter } from '@/common/components/FilterDrawer/FilterDrawer';
import { SuperExperiment } from '@/lib/App';

interface ExperimentsTableProps {
  id: string;
  tabView: ExperimentTabView;
  columns: ColumnsType<SuperExperiment>;
  dataSource: SuperExperiment[] | undefined;
  filters: { [key: string]: any };
  filterFields: Filter[];
  searchVal: string;
  pageNumber: number;
  pageSize: number;
  total: number | undefined;
  loading: boolean;
  filtersExcludeFromCount: string[];
  rightActions?: React.ReactNode[];
  onSearch: (
    searchVal: string,
    filters: { [key: string]: any },
    pageNumber: number,
    pageSize: number,
    type: string,
  ) => void;
  onFilterClick: () => void;
  onColumnsRefresh?: (visibleColumns: any[]) => void;
}

const ExperimentsTable: React.FC<ExperimentsTableProps> = ({
  id,
  columns,
  dataSource,
  filters,
  filterFields,
  searchVal,
  pageNumber,
  pageSize,
  total,
  loading,
  filtersExcludeFromCount,
  rightActions,
  onSearch,
  onFilterClick,
  onColumnsRefresh,
}) => {
  return (
    <DashboardTable
      onSearch={onSearch}
      id={id}
      rowClassName="exp-dashboard-v2"
      columns={columns}
      rowKey={(record: SuperExperiment) => record.name}
      filtersExcludeFromCount={filtersExcludeFromCount}
      dataSource={dataSource}
      searchVal={searchVal}
      onFilterClick={onFilterClick}
      filterFields={filterFields}
      filters={filters}
      pageNo={pageNumber}
      pageSize={pageSize}
      searchPlaceholder="Search by name"
      rightActions={rightActions}
      total={total}
      loading={loading}
      bordered={false}
      tableColumnsRefresh={onColumnsRefresh}
    />
  );
};

export default ExperimentsTable;
